import React, { useEffect, useState } from 'react';
import styles from './otherReviews.module.scss';
import ReactGA from 'react-ga';
import { Helmet } from "react-helmet";
import CustomNavbar from '../customNavbar';
import { Card, Col, Container, Image, Row } from 'react-bootstrap';
import { CustomButton } from '../../shared/customButton';
import { getExternalAssessmentsCards } from '../../../services/util/externalAssessments';
import CSSLoader from '../../shared/cssLoader';
import ReactTooltip from 'react-tooltip';
import { CustomAvatarList } from '../../shared/customAvatarList';
import { CustomPreIcon } from '../../shared/customPreIcon';

function OtherReviews(props) {
    let concatValue;
    const [isLoading, setLoading] = useState(false);
    let [card_details, set_card_details] = useState([]);
    let [isURLLoading, setURLLoading] = useState(false);

    const breadcrumb = [
        {
            pathaddress: '/app/company/external-assessments',
            pathname: 'External Assessments',
            isActive: true,
            key: 1 + 'External Assessments'
        }
    ];

    const viewAssessmentDetails = (step_id) => {
        props.history.push({
            pathname: `/app/company/external-assessments/group`,
            search: `?step_id=${step_id}`
        });
    }

    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    function truncateValue(value, maxLength) {
        return value.length > maxLength ? value.slice(0, maxLength - 1) + "…" : value;
    }


    async function loadInitialData() {
        setLoading(true);
        let respond = await getExternalAssessmentsCards();
        if (respond.success === true) {
            set_card_details(respond.data);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }


    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            loadInitialData();
        }
        return () => { unmounted = true };
    }, [])

    useEffect(() => {
        let pageHit = '/app/company/external-assessments';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])

    return (
        <div>
            <Helmet>
                <title>External Assessment Reviews | HireTrace</title>
            </Helmet>
            {isLoading === true ?

                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <Row>
                                {
                                    (card_details).map((value, index) => (
                                        <Col sm={6} lg={4} className="mb-4" key={index}>

                                            <Card className={styles.cardOuterBox}>
                                                <Card.Body >
                                                    <div className={styles.cardTitleBox}>
                                                        <CustomPreIcon
                                                            type="successIcon"
                                                            icon={
                                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g id="book-open-02">
                                                                        <path id="Icon" d="M12 20H5.2C4.07989 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2C2 6.07989 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.07989 4 5.2 4H5.6C7.84021 4 8.96031 4 9.81596 4.43597C10.5686 4.81947 11.1805 5.43139 11.564 6.18404C12 7.03968 12 8.15979 12 10.4M12 20V10.4M12 20H18.8C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H18.4C16.1598 4 15.0397 4 14.184 4.43597C13.4314 4.81947 12.8195 5.43139 12.436 6.18404C12 7.03968 12 8.15979 12 10.4" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                </svg>
                                                            }
                                                        />
                                                        <div className={styles.cardTitleText}>
                                                            <p className={styles.cardTitlePrimaryText} data-tip data-for={value.pipeline_name + index} onChange={addMaxViewLength(value.pipeline_name, 80)}>{concatValue}</p>
                                                            {(value.pipeline_name).length > 80 &&
                                                                <ReactTooltip id={value.pipeline_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{value.pipeline_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                            <p className={styles.cardTitleSecondaryText}>
                                                                {truncateValue(value.hiring_position, 22)}
                                                                {" | "}
                                                                {truncateValue(value.step_name, 22)}
                                                            </p>

                                                            {(value.hiring_position).length > 22 &&
                                                                <ReactTooltip id={value.hiring_position + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{value.hiring_position}</span>
                                                                </ReactTooltip>
                                                            }
                                                            {(value.step_name).length > 22 &&
                                                                <ReactTooltip id={value.step_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{value.step_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </div>
                                                    </div>
                                                    <hr className={styles.horizontalDivider} />
                                                    <div className={styles.cardBodyText}>
                                                        <p >
                                                            {`${value.job_type === 10 ? "Full-Time" : value.job_type === 20 ? "Part-Time" : value.job_type === 30 ? "Contact / Temp" : value.job_type === 50 ? "Casual / Vacation" : ''}`}
                                                            {`${value.work_type === 10 ? " | Remote" : value.work_type === 20 ? " | On-site" : value.work_type === 30 ? " | Hybrid" : ''}`}
                                                            {`${value.location ? ` | ${value.location}` : ''}`}
                                                        </p>
                                                    </div>
                                                    <div className={styles.reviewDetails}>
                                                        <div>
                                                            <CustomAvatarList nameArray={value.top_candidate_name_list} totalUsers={value.candidate_count}></CustomAvatarList>
                                                        </div>
                                                        <div className={styles.cardBtn}>

                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Start Review"
                                                                type="secondaryBtn"
                                                                backicon={
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => viewAssessmentDetails(value.step_id)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>


                                        </Col>
                                    ))

                                }

                            </Row>

                        </Col>
                        <div className={styles.NoContainer}>
                            {
                                ((card_details).length === 0) &&
                                (<div>
                                    <Col>
                                        <p className={styles.infoMessage}>Currently no external assessments assigned to you to review. Learn more
                                            about  <a href='https://hiretrace.io/documentation/external-assessments/overview' target="_blank">External Assessments</a>. </p>
                                    </Col>
                                    <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/exam.svg`} fluid />
                                    </Col>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default OtherReviews;
